import { css } from '@styled-system/css';
import { token } from '@styled-system/tokens';
import { type FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// import { Logo } from './Logo';

interface RoundedCloseButtonProps {
  onClick: () => void;
  className?: string;
}

export const RoundedCloseButton: FC<RoundedCloseButtonProps> = ({ onClick, className }) => {
  const { t } = useTranslation();
  // Gestion de la touche Escape
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClick]);

  const closeButtonStyles = css({
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'xl',
    border: '1px solid',
    borderColor: 'base.selectedBg',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    zIndex: 10,
    '&:hover': {
      backgroundColor: 'base.selectedBg',
    },
  });

  return (
    <button className={`${closeButtonStyles} ${className || ''}`} onClick={onClick} type="button" aria-label={t('common.close')}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path
          d="M1.42525 1.42497L8.6466 8.64632M1.42525 8.64632L8.6466 1.42497"
          stroke={token.var('colors.font.secondary')}
          strokeWidth="1.70209"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
